import axios from 'axios'

// For list fetches whose filters change in quick succession (e.g. picking a
// domain, then a room): starting a request cancels the previous one, and
// isStale() tells a response that a later request has superseded it, so a
// slower earlier response can't overwrite the newer list.
//
//   const startAdvicesRequest = createLatestRequest()
//   const { cancelToken, isStale } = startAdvicesRequest()
//   axios.get(url, { params, cancelToken }).then((body) => {
//     if (isStale()) return
//     ...
//   }).catch((error) => {
//     if (axios.isCancel(error) || isStale()) return
//     ...
//   })
export const createLatestRequest = () => {
  let seq = 0
  let source = null
  return () => {
    if (source) {
      source.cancel()
    }
    const current = axios.CancelToken.source()
    source = current
    const requestSeq = ++seq
    return {
      cancelToken: current.token,
      isStale: () => requestSeq !== seq
    }
  }
}
